import { useMemo } from "react";
import { useAppSelector } from "../store/hooks";
import {
  canManageAttendance,
  isHrAdminEmployee,
  isSuperAdminAccess,
} from "../utils/employeeRoles";

export function useHrAccess() {
  const { user } = useAppSelector((state) => state.auth);
  const { employee } = useAppSelector((state) => state.allocationAuth);

  return useMemo(() => {
    const portalRole = user?.role || "";
    const empRole = String(employee?.role || "").trim().toLowerCase();
    const isSuperAdmin = isSuperAdminAccess(portalRole, employee?.role);
    const isDeveloper = empRole === "developer";
    // Developer / Operations are staff for HR (own attendance / leave only), like CRM / Captain.
    const isCrmAdmin =
      (portalRole === "Operations" && isHrAdminEmployee(employee?.role)) ||
      (portalRole === "Production" && empRole === "admin");
    // Portal Super Admin and employee Super Admin share the same HR / dashboard access.
    const isHrAdmin = isSuperAdmin || isCrmAdmin;
    const canEditEmployeeRecords = canManageAttendance(portalRole, employee?.role);
    const canMarkAttendance = canEditEmployeeRecords;
    // Notebook connection stays a Developer/Super Admin tool; not team HR.
    const canEditNotebook = isSuperAdmin || isDeveloper;
    const portalAllowed = isHrAdmin || canEditNotebook;
    const needsEmployeeLogin =
      (portalRole === "Operations" || portalRole === "Production") && !isSuperAdmin;

    return {
      portalAllowed,
      isHrAdmin,
      isSuperAdmin,
      canEditEmployeeRecords,
      canMarkAttendance,
      canEditNotebook,
      needsEmployeeLogin,
      employee,
      user,
      empId: employee?.emp_id ?? null,
    };
  }, [user, employee]);
}
